// extracted by mini-css-extract-plugin
module.exports = {"title":"_fe2ab97","list":"_b574dad5","link":"_e8e88d37","item":"_ade9ec2","container":"_b4d69890"};